import React from 'react';
import { VideoPlaceholder } from '../../../components/Layout';
import ThirdPartyVideoPlayer from '../../../components/ThirdPartyVideoPlayer';

export const VideoPreview = ({ url }: { url: string }) => {
  if (!url || !url.trim()) {
    return null;
  }

  return (
    <VideoPlaceholder thirdParty>
      <ThirdPartyVideoPlayer url={url} />
    </VideoPlaceholder>
  );
};
